import React, { useState, useContext } from 'react';
import { Table, Pagination, Button } from 'rsuite';
import './add-accounts-manually.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../../utils/i18n';
import { ActionLink, ModalWindow, Dropdown } from '../../../atoms';
import { UserContext, FilterContext } from '../../../../context';
import { AdminService } from '../../../../services';

function AddAccountsManually({
  addAccountsModal,
  handleOpenSliderModal,
  selectedAccounts,
  accountId,
  onRemove,
}) {
  const { filterDetails, setFilterDetails } = useContext(FilterContext);
  const countriesList = filterDetails?.countryList;
  const industriesList = filterDetails?.industryList;
  const verticalList = filterDetails?.verticalList;
  const advertiserList = filterDetails?.advertiserList;
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [accountDetails, setAccountDetails] = useState({});

  const handleOnCancel = e => {
    e.preventDefault();
    handleOpenSliderModal(false);
  };

  const onAdd = () => {
    let ids = [];
    selectedAccounts?.forEach(acc => {
        let splitId = acc?.accountId.split('_')[1]
      ids.push(splitId);
    });
    const payload = {
      businessAccountId: accountId,
      adAccountIds: ids.toString(),
      countryCode: accountDetails?.countryCode,
      advertiser: accountDetails?.advertiser,
      vertical: accountDetails?.vertical,
      subVertical: accountDetails?.subVertical,
    };
    addAccounts(payload)
  };

  const addAccounts = async (payload) => {
    try {
        const listResponse = await AdminService.AddAccounts(
          userAccessToken,
          username,
          payload
        );
        const addRes = listResponse.data?.data;
        handleOpenSliderModal(false, true);
    } catch (error) {
        const dataCode = error?.data?.data?.code;
      }  
  }

  const getVal = (list, code) => {
    return list?.find(li => li.value === code);
  };

  const handleSelect = (option, selectedDropdown) => {
    switch (selectedDropdown) {
      case 1:
        setAccountDetails({ ...accountDetails, countryCode: option?.value });
        break;
      case 2:
        setAccountDetails({ ...accountDetails, vertical: option?.value });
        break;
      case 3:
        setAccountDetails({ ...accountDetails, subVertical: option?.value });
        break;
      case 4:
        setAccountDetails({ ...accountDetails, advertiser: option?.value });
        break;
    }
  };

  const onRemoveAcc = (value, account) => {
    onRemove(value, account);
  };

  return (
    <div>
      <div className="attr-delete accounts-add-container">
        <ModalWindow
          className="fqa-modal--addAccounts fqa-modal--manually"
          isOpen={addAccountsModal}
          onRequestClose={handleOnCancel}
          heading={t('admin.adaccounts.manually.header')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <div className="ac_id ac_id_space">{t('admin.add.bm.id')}: {accountId}</div>
          <div className="ac_id">{t('admin.add.ac.id')}</div>
          <div className="campaigns-list-container">
            <div className="list-scroll-container">
              <div className="list-scroll">
                <div className="selected-list">
                  {selectedAccounts?.map(item => {
                    return (
                      <div className="selected-item" key={item.accountId}>
                        <span className="selected-value" title={item?.accountId}>
                          {item?.accountId}
                        </span>
                        <span className="cross" onClick={e => onRemoveAcc(e, item)}>
                          <i className="eva eva-close-outline clear-icon"></i>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="c-dropdown-country">
            <Dropdown
              className="user-select"
              heading={t('admin.add.adv.name')}
              value={getVal(advertiserList, '')}
              options={advertiserList}
              placeholder={t('admin.add.select.advertiser')}
              tooltipIndicator={false}
              isImportant={false}
              onSelect={opt => handleSelect(opt, 4)}
              isCreateNewOption={true}
            />
          </div>
          <div className="c-dropdown-country">
            <Dropdown
              className="user-select"
              heading={t('admin.adaccount.country')}
              value={getVal(countriesList, '')}
              options={countriesList}
              placeholder={t('admin.add.country')}
              tooltipIndicator={false}
              isImportant={false}
              onSelect={opt => handleSelect(opt, 1)}
            />
          </div>
          <div className="c-dropdown-country">
            <Dropdown
              className="user-select"
              heading={t('admin.adaccount.industry')}
              value={getVal(industriesList, '')}
              options={industriesList}
              placeholder={t('admin.add.industry')}
              tooltipIndicator={false}
              isImportant={false}
              onSelect={opt => handleSelect(opt, 2)}
              isCreateNewOption={true}
            />
          </div>
          <div className="c-dropdown-country">
            <Dropdown
              className="user-select"
              heading={t('admin.adaccount.vertical')}
              value={getVal(verticalList, '')}
              options={verticalList}
              placeholder={t('admin.add.sub.vertical')}
              tooltipIndicator={false}
              isImportant={false}
              onSelect={opt => handleSelect(opt, 3)}
              isCreateNewOption={true}
            />
          </div>

          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('admin.add.close')}
              handleClick={handleOnCancel}
            />
            <Button className="fqa-model-pa--actions-confirm delete-button" onClick={onAdd} disabled={!selectedAccounts?.length}>
              {t('admin.cta.add.account')}
            </Button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}
export default AddAccountsManually;
